import classNames from "classnames";
import "./styles.scss";

export interface PanelProps {
  children: React.ReactNode;
  className?: string;
  isUsedInMinimalTipTapViewModal?: boolean;
  overflowVisible?: boolean;
  withBorder?: boolean;
}

export const Panel = ({
  children,
  overflowVisible = true,
  withBorder = true,
  isUsedInMinimalTipTapViewModal = false,
  className,
}: PanelProps) => (
  <div
    className={classNames(
      "content-panel",
      {
        "overflow-hidden": !overflowVisible,
      },
      className,
    )}
  >
    <div
      className={classNames(
        "content-panel__container !bg-primary !shadow-none",
        {
          "border-primary border": withBorder,
          "!mx-0": isUsedInMinimalTipTapViewModal,
        },
      )}
    >
      {children}
    </div>
  </div>
);
